export default __webpack_public_path__ + "static/media/whitepaperHindi.f0f2693e.pdf";